import { ChatStatusType } from "@nib-group/chatbot-shared/types";
export default {
  TITLE: "Inline chat window",
  STATUS_TEXT: {
    LOADING: "Connecting...",
    RESUMING: "Resuming...",
    ERROR: "Something went wrong",
    CHAT_STATUS_MSG: {
      [ChatStatusType.TalkingToBot]: "Connected",
      [ChatStatusType.Transferring]: "Transferring...",
      [ChatStatusType.TalkingToAgent]: function () {
        let agentName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return `Chatting to ${agentName === "" ? "a human" : agentName}`;
      },
      [ChatStatusType.Ended]: "Thanks for chatting!",
      // Technically, this one should never be set
      // (as the loading/error checks should precede it)
      [ChatStatusType.NotStarted]: "",
      [ChatStatusType.Expired]: "Session expired"
    }
  }
};